module.exports = __webpack_public_path__ + "static/media/riskbanner@2x.c7d7f44d.png";